/** Consent checkbox for QuoteWizard's contact step - shared since text/link are identical for privat and erhverv. BusinessLPWizard uses different consent text/styling. */
export function ConsentCheckbox({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
}) {
  return (
    <div className="mb-6">
      <label
        htmlFor="wiz-consent"
        className="flex cursor-pointer items-start gap-2.5 text-sm text-ink-muted"
      >
        <input
          id="wiz-consent"
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-0.5 h-4 w-4 shrink-0 cursor-pointer accent-theme-accent"
        />
        <span>
          Jeg accepterer at rengøringidanmark.dk viser min opgave til godkendte rengøringsfirmaer i
          mit område, og at det firma, jeg bliver matchet med, må kontakte mig med et tilbud på
          telefon og e-mail. Jeg kan vælge et andet firma eller sige fra på den side, jeg ser lige
          efter.{" "}
          <a
            href="/privatlivspolitik"
            className="text-link underline underline-offset-2 hover:text-ink"
          >
            Privatlivspolitik
          </a>
        </span>
      </label>
    </div>
  );
}
